import React, { Fragment } from 'react'
import RefundConfirmation from './RefundConfirmation'

const RefundConfirmationModal = () => {
  return (
    <Fragment>
      <RefundConfirmation />
    </Fragment>
  )
}

RefundConfirmationModal.propTypes = {}

export default RefundConfirmationModal
